import * as LinkedList from './linked-list.js'; // 事件

export function Event() {
  var tasks = LinkedList.LinkedList();
  return {
    register: function register(task) {
      var node = LinkedList.insert(tasks, task);
      return {
        remove: function remove() {
          return LinkedList.remove(tasks, node);
        }
      };
    },
    trigger: function trigger(arg) {
      return LinkedList.each(tasks)(function (task) {
        return task(arg);
      });
    }
  };
} // 只触发一次的事件

export function Once() {
  var tasks = LinkedList.LinkedList();
  return {
    register: function register(task) {
      if (tasks) {
        var node = LinkedList.insert(tasks, task, null);
        return {
          remove: function remove() {
            return LinkedList.remove(tasks, node);
          }
        };
      }

      task();
      return {
        remove: function remove() {
          return undefined;
        }
      };
    },
    trigger: function trigger() {
      if (tasks) {
        LinkedList.each(tasks)(function (task) {
          return task();
        });
      }

      tasks = null;
    }
  };
} // 事件只触发一次

export function one(bind) {
  return function (response) {
    var handle = bind(function (e) {
      response(e);
      handle.remove();
    });
    return handle;
  };
}